import { makeObservable, observable } from 'mobx';
import { inject, injectable } from '@servicetitan/react-ioc';
import { getTagFromEnv } from '../utils/get-tag-from-env';
import { AppStore } from '../../../../common/stores/app.store';

@injectable()
export class TransparentMarketingStore {
    @observable src =
        'https://unpkg.servicetitan.com/@servicetitan/marketing-campaign-management-admin';

    constructor(@inject(AppStore) private readonly appStore: AppStore) {
        makeObservable(this);

        this.init();
    }

    private init = () => {
        const tag = getTagFromEnv(this.appStore.appConfigs.environmentTag);

        this.src += `@${tag}`;
    };
}
